import { parseFloatUniversal, roundOptionalDigits } from "./numberUtils";
var WakeUpIntervalDigits = 2;
export function calculateIntervalStringAndType(interval) {
    var intervalType;
    var intervalString;
    if (interval % intervalMultiplier(WakeupIntervalType.DAY) === 0) {
        intervalType = WakeupIntervalType.DAY;
        intervalString = roundOptionalDigits(interval / intervalMultiplier(WakeupIntervalType.DAY), WakeUpIntervalDigits).toString();
    }
    else if (interval % intervalMultiplier(WakeupIntervalType.HOUR) === 0) {
        intervalType = WakeupIntervalType.HOUR;
        intervalString = roundOptionalDigits(interval / intervalMultiplier(WakeupIntervalType.HOUR), WakeUpIntervalDigits).toString();
    }
    else {
        intervalType = WakeupIntervalType.MINUTE;
        intervalString = roundOptionalDigits(interval / intervalMultiplier(WakeupIntervalType.MINUTE), WakeUpIntervalDigits).toString();
    }
    return { intervalType: intervalType, intervalString: intervalString };
}
export function calculateRawIntervalValue(interval, intervalType) {
    var convertedInterval = parseFloatUniversal(interval);
    if (isNaN(convertedInterval)) {
        return null;
    }
    return convertedInterval * intervalMultiplier(intervalType);
}
export var minWakeUpIntervalSeconds = 4 * 60; //4 minutes
export var maxWakeUpIntervalSeconds = 7 * 24 * 60 * 60; //1 week
export function isAllowedInterval(intervalSeconds) {
    //for now scoped to GEN2 with static bounds.
    return intervalSeconds >= minWakeUpIntervalSeconds && intervalSeconds <= maxWakeUpIntervalSeconds;
}
export function getAllowedValue(interval) {
    //max value for any value over max value
    //min value for any value below min value
    if (isAllowedInterval(interval)) {
        return interval;
    }
    else if (interval > maxWakeUpIntervalSeconds) {
        return maxWakeUpIntervalSeconds;
    }
    else {
        return minWakeUpIntervalSeconds;
    }
}
// Multiplier for converting seconds into the supplied intervalType.
// For reverse calculating it can be used as divisor
function intervalMultiplier(intervalType) {
    switch (intervalType) {
        case WakeupIntervalType.MINUTE:
            return 60;
        case WakeupIntervalType.HOUR:
            return 3600;
        case WakeupIntervalType.DAY:
            return 86400;
    }
}
export function wakeUpIntervalTypeText(type, intl) {
    switch (type) {
        case WakeupIntervalType.MINUTE:
            return intl.formatMessage({ id: 'device.settings.wakeupinterval.minute' });
        case WakeupIntervalType.HOUR:
            return intl.formatMessage({ id: 'device.settings.wakeupinterval.hour' });
        case WakeupIntervalType.DAY:
            return intl.formatMessage({ id: 'device.settings.wakeupinterval.day' });
    }
}
export var WakeupIntervalType;
(function (WakeupIntervalType) {
    WakeupIntervalType[WakeupIntervalType["DAY"] = 0] = "DAY";
    WakeupIntervalType[WakeupIntervalType["HOUR"] = 1] = "HOUR";
    WakeupIntervalType[WakeupIntervalType["MINUTE"] = 2] = "MINUTE";
})(WakeupIntervalType || (WakeupIntervalType = {}));
